import { isVisibleComponetBaseOnRole } from "@/commons/RoleFunction.ts";
import { FluentProvider, IOption } from "@/dependencies";
import {
  Dropdown,
  DropdownProps,
  Listbox,
  makeStyles,
  Option,
  OptionOnSelectData,
  SelectionEvents,
  Slot,
} from "@fluentui/react-components";
import { useEffect, useState } from "react";

interface DropdownPropsCustom {
  rcName?: string;
  theme?: string;
  name?: string;
  rcRole?: string[];
  requireRoles?: string[];
  selectedOptions?: string[];
  defaultSelectedOptions?: string[];
  multiselect?: boolean;
  disabled?: boolean;
  options?: IOption[];
  listbox?: Slot<typeof Listbox>;
  onSelectOption?: (event: SelectionEvents, data: OptionOnSelectData) => void;
  placeholder?: string;
}


const useStyles = makeStyles({
  disabled: {
    backgroundColor: "var(--colorSubtleBackgroundHover)",
    "& input": {
      color: "var(--colorNeutralForeground1)",
    },
  },
});

const DropdownCustom = (props: DropdownPropsCustom & DropdownProps) => {
  const styles = useStyles();
  const [options, setOptions] = useState<IOption[]>([]);
  const [mapOptions, setMapOptions] = useState<Record<string, IOption>>({});
  const isCanBeVisible = isVisibleComponetBaseOnRole(
    props.rcRole,
    props.requireRoles,
  );

  useEffect(() => {
    setOptions([...(props.options || [])]);
    const mapTemp: Record<string, IOption> = {};
    props.options?.forEach((item) => {
      mapTemp[item.value] = item;
    });
    setMapOptions(mapTemp);
  }, [props.options]);

  const onOptionSelect = (event: SelectionEvents, data: OptionOnSelectData) => {
    if (props.onSelectOption) {
      props.onSelectOption(event, data);
    }
  };

  const isDisabled = props.disabled || !isCanBeVisible;
  return props.theme ? (
    <FluentProvider theme={props.theme}>
      <Dropdown
        {...(props.selectedOptions
          ? { selectedOptions: props.selectedOptions }
          : { defaultSelectedOptions: props.defaultSelectedOptions })}
        onOptionSelect={onOptionSelect}
        multiselect={props.multiselect}
        disabled={isDisabled}
        listbox={props.listbox}
        placeholder={props.placeholder}
        button={
          props.selectedOptions?.length
            ? props.selectedOptions
                .map((item) => mapOptions[item]?.text)
                .join(", ")
            : undefined
        }
        className={`${isDisabled ? styles.disabled : ""}`}
      >
        {(options || []).map((item, index) => (
          <Option key={`${props.rcName}-${index}`} value={item.value}>
            {item.text}
          </Option>
        ))}
      </Dropdown>
    </FluentProvider>
  ) : (
    <Dropdown
      {...(props.selectedOptions
        ? { selectedOptions: props.selectedOptions }
        : { defaultSelectedOptions: props.defaultSelectedOptions })}
      onOptionSelect={onOptionSelect}
      multiselect={props.multiselect}
      disabled={isDisabled}
      listbox={props.listbox}
      placeholder={props.placeholder}
      button={
        props.selectedOptions?.length
          ? props.selectedOptions
              .map((item) => mapOptions[item]?.text)
              .join(", ")
          : undefined
      }
      className={`${isDisabled ? styles.disabled : ""}`}
    >
      {(options || []).map((item, index) => (
        <Option key={`${props.rcName}-${index}`} value={item.value}>
          {item.text}
        </Option>
      ))}
    </Dropdown>
  );
};

export default DropdownCustom;
